module.exports = __webpack_public_path__ + "img/f2-en.8c1a6348.jpeg";